import PropTypes from 'prop-types'
import { Component } from 'react'
import { giphyGreen, giphyRed, giphyIndigo } from 'shared/css/colors.css'
import css from './notifications.css'

export class Notification extends Component {
    static propTypes = {
        isTimed: PropTypes.bool,
        onCancel: PropTypes.func.isRequired,
        message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        backgroundColor: PropTypes.string,
    }
    static defaultProps = {
        isTimed: false,
        backgroundColor: giphyIndigo,
    }
    shouldComponentUpdate() {
        return false
    }
    printMessage(message) {
        if (!message.details) {
            return <p className={css.message}>{message}</p>
        }

        const { details } = message
        const invalidFields = Object.keys(details)
        return invalidFields.map(field => {
            const fieldValidationErrors = details[field]
            return (
                <div key={field}>
                    <p className={css.title}>{field}</p>
                    {fieldValidationErrors.map(error => (
                        <p key={error} className={css.message}>
                            {error}
                        </p>
                    ))}
                </div>
            )
        })
    }

    render() {
        const { isTimed, message, onCancel, backgroundColor } = this.props
        return (
            <div className={css.container}>
                <div
                    className={isTimed ? css.timedContentContainer : css.contentContainer}
                    style={{ backgroundColor }}
                    onAnimationEnd={() => onCancel()}
                >
                    <div className={css.content}>{this.printMessage(message)}</div>
                    <i className={css.cancel} onClick={() => onCancel()} />
                </div>
            </div>
        )
    }
}

const Notifications = ({ error, success, clearSuccessMessage, clearErrorMessage, inline }) => (
    <div className={inline ? css.notificationsInline : css.notifications}>
        {error.map(({ id, message }) => (
            <Notification
                message={message}
                backgroundColor={giphyRed}
                onCancel={() => clearErrorMessage(id)}
                key={id}
            />
        ))}
        {success.map(({ id, message }) => (
            <Notification
                message={message}
                backgroundColor={giphyGreen}
                onCancel={() => clearSuccessMessage(id)}
                isTimed={true}
                key={id}
            />
        ))}
    </div>
)

export default Notifications
